<span class="p-float-label">
    <p-password class="p-inputtext-sm" [id]="id" (input)="onInput($event)" [feedback]="feedback"
                [disabled]="formControl['disabled']"></p-password>
    <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+field) | translate"></label>
    <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
                          [required]="formControl.errors?.['required']"
                          [passwordRepeat]="formControl.errors?.['passwordRepeat']"></app-form-input-error>
</span>
